module.exports = __webpack_public_path__ + "static/img/5.e525806.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/eng/5.png
// module id = akwQ
// module chunks = 0